import React from 'react';

import useStylesheet from './WideCell.stylesheet';
import Cell, { OuterProps as CellProperties } from './Cell';

interface OuterProps extends CellProperties {
  first: boolean;
  last: boolean;
}

const PureWideCell = ({ colorway, cell, first, last }: OuterProps) => {
  const { styles } = useStylesheet({
    first,
    last,
  });
  return (
    <div style={styles.cell}>
      <Cell colorway={colorway} cell={cell} />
    </div>
  );
};

PureWideCell.displayName = 'WideCell';

export default PureWideCell;
